var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-filter-ref-editor mt-4"},[_c('span',{staticClass:"mb-1",staticStyle:{"font-size":"13px"}},[_vm._v(" Company Filter: ")]),_c('CompanyFilterRefSelect',{model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}}),_c('ValidationErrors',{attrs:{"errors":_vm.errors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }